// EXPERIMENT: sign_form_signer_carousel_colors_experiment — remove with experiment cleanup
import type React from 'react';
import { useCallback, useContext } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { CarouselSeenContext } from '#src/app/pages/petitionDetails/shared/components';
import { Waypoint } from '#src/app/shared/components/scroll';

type Props = Readonly<{
	/** Distinct signers rendered, before the feed doubles them for the seamless scroll effect. */
	signerCount: number;
}>;

/**
 * Reports the carousel as seen each time it enters the viewport; `SignerCarouselColorsTracking` dedups.
 *
 * `onEnter`, not `onPositionChange`: a `display: none` copy of the carousel has an all-zero rect that
 * `calculatePosition` classifies as `'inside'`, which would report impressions nobody could see.
 */
export const RecentSignersFeedImpression: React.FC<Props> = ({ signerCount }) => {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();
	const reportCarouselSeen = useContext(CarouselSeenContext);

	const onEnter = useCallback(
		() => reportCarouselSeen(`petition_${id}`, signerCount),
		[id, signerCount, reportCarouselSeen],
	);

	return <Waypoint onEnter={onEnter} />;
};
